export class GoogleTagManager {
    public static shared = new GoogleTagManager();

    private readonly dataLayer: any[];

    private constructor() {
        window["dataLayer"] = window["dataLayer"] || [];
        this.dataLayer = window["dataLayer"];
        this.dataLayer.push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js",
        });
    }

    private loadScript() {
        const containerId = "GTM-P6H7RF9V";
        const scriptId = `google-tag-manager-${containerId}`;
        if (document.getElementById(scriptId)) {
            return;
        }
        const script = document.createElement("script");
        script.id = scriptId;
        script.type = "text/javascript";
        script.async = true;
        script.onload = () => {
            console.log("gtm onload");
        };
        script.onerror = () => {
            console.log("gtm onerror");
            const scr = document.getElementById(scriptId);
            if (scr) {
                scr.parentNode?.removeChild(scr);
            }
        };
        script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
        const head = document.getElementsByTagName("head")[0];
        head.appendChild(script);
    }

    public init() {
        this.loadScript();
    }

    public report(name: string, data?: { [key: string]: string | number | boolean | undefined }) {
        this.dataLayer.push({
            event: name,
            ...data,
        });
    }
}
